
import {
  defineComponent,
  ref,
  Ref,
  computed,
  inject,
  onMounted,
  toRef,
  nextTick,
  onUnmounted,
} from "vue";
import { store } from "@/store";
import CloseSVG from "@/components/CloseSVG.vue";
import { ActionTypes } from "@/store/actions";
import { CurrentLabel } from "@/types";

export default defineComponent({
  components: {
    CloseSVG,
  },
  props: {
    idx: Number,
  },
  setup(props) {
    const idxRef = toRef(props, "idx");
    if (idxRef.value !== 0 && idxRef.value !== 1) {
      throw new Error("Missing necessary prop, CustomLabelSizes.vue");
    }

    const closeModal = inject("closeModal") as () => void;
    const bounceTransition = inject("bounceTransition") as Ref<string>;
    const fadeTransition = inject("fadeTransition") as Ref<string>;

    const currentLabel = computed<CurrentLabel>(() => store.getters.currentLabel);
    const customLabelSizes = computed<[number[], number[]]>(() => store.getters.customLabelSizes);

    const labelSizes = ref<number[]>([]);
    onMounted(async () => {
      labelSizes.value = customLabelSizes.value[idxRef.value ? idxRef.value : 0];

      if (idxRef.value === 0) {
        const foundSize = labelSizes.value.find(
          (label: number) => label === currentLabel.value.width
        );

        await nextTick();
        if (foundSize) {
          const sizeContainer = document.getElementById(foundSize.toString());

          if (sizeContainer) {
            sizeContainer.style.background = "#0096ff15";

            const listContainer = document.getElementById("modal-sizes-container");

            if (listContainer) {
              const sizeContainerBoundingRect = sizeContainer.getBoundingClientRect();
              const listContainerBoundingRect = listContainer.getBoundingClientRect();

              // prettier-ignore
              listContainer.scroll(0, sizeContainerBoundingRect.top - listContainerBoundingRect.top - sizeContainerBoundingRect.height / 2);
            }
          }
        }
      } else {
        const foundSize = labelSizes.value.find(
          (label: number) => label === currentLabel.value.height
        );

        await nextTick();
        if (foundSize) {
          const sizeContainer = document.getElementById(foundSize.toString());

          if (sizeContainer) {
            sizeContainer.style.background = "#0096ff15";

            const listContainer = document.getElementById("modal-sizes-container");

            if (listContainer) {
              const sizeContainerBoundingRect = sizeContainer.getBoundingClientRect();
              const listContainerBoundingRect = listContainer.getBoundingClientRect();

              // prettier-ignore
              listContainer.scroll(0, sizeContainerBoundingRect.top - listContainerBoundingRect.top - sizeContainerBoundingRect.height / 2);
            }
          }
        }
      }
    });

    const currentlySelectedSize = ref(
      idxRef.value === 0 ? currentLabel.value.width : currentLabel.value.height
    );
    const selectedLabelSize = ref(0);

    const validateTarget = (target: EventTarget | null): target is HTMLInputElement => {
      return target !== null && target !== undefined;
    };

    const handleInput = (target: EventTarget | null, id: number): void => {
      if (validateTarget(target)) {
        const selectedSize = target.value;
        const foundSize = labelSizes.value.find((label: number) => label === Number(selectedSize));

        if (foundSize) {
          const sizeContainer = document.getElementById(id.toString());
          const prevSizeContainer = document.getElementById(currentlySelectedSize.value.toString());

          if (sizeContainer && prevSizeContainer) {
            prevSizeContainer.style.background = "";

            sizeContainer.style.background = "#0096ff15";
            currentlySelectedSize.value = id;
          }

          selectedLabelSize.value = foundSize;
        }
      }
    };

    const changeLabelSize = async (): Promise<void> => {
      await store.dispatch(ActionTypes.CHANGE_CUSTOM_LABEL_SIZE, {
        dimension: idxRef.value === 0 ? "width" : "height",
        value: selectedLabelSize.value,
      });
      closeModal();
    };

    return {
      idxRef,
      closeModal,
      bounceTransition,
      fadeTransition,
      currentLabel,
      labelSizes,
      handleInput,
      changeLabelSize,
    };
  },
});
